import Server from './../../libs/server';
import Vue from 'vue';

const local = {
    _protectionCode: '',
    _showHiddenChannels: false,
    _lastUpdated: 0 // время последнего запроса списка каналов
};

const state = {
    channels: [],
    groups: [],
    currentChannel: false,
    favoriteChannels: [],
    channelsAspectRatio: {},
    loadingChannel: true,
    protectionCode: '',
    player: null,
    // showHiddenChannels: false
};

const actions = {
    setChannelsState({commit, dispatch, state}, values) {
        commit('SET', values);
    },

    showHiddenChannel({commit, dispatch}, channelId) {
        commit('SET_CHANNEL_VISIBILITY', {channelId, value: false});
    },
    hideVisibleChannel({commit, dispatch}, channelId) {
        commit('SET_CHANNEL_VISIBILITY', {channelId, value: true});
    },

    getChannelList({commit, dispatch, state}, {showHiddenChannels = local._showHiddenChannels, protectionCode = state.protectionCode, ignoreLastUpdated = false}) {
        return new Promise((resolve, reject) => {
            let groups = [];
            let channels = [];

            let now = Math.trunc((new Date()).getTime() / 1000);

            if (!local._lastUpdated || (now - local._lastUpdated) >= 10 || ignoreLastUpdated) { // время получение ответа, чтобы не повторять запрос
                local._lastUpdated = now;

                Server.getChannelList(showHiddenChannels, protectionCode, (err, data) => {
                    if (err) {
                        console.error(err.message);
                        location.reload();
                    } else {
                        if (data.error) {
                            reject(data.error);
                        }
                        else {
                            for (let group of data.groups) {
                                groups.push({
                                    id: group.id,
                                    name: group.name,
                                    color: group.color
                                });

                                for (let channel of group.channels) {
                                    channels.push({
                                        id: channel.id,
                                        group_id: group.id,
                                        name: channel.name,
                                        icon: '//iptvn.idc.md/'+channel.big_icon,
                                        epg_progname: channel.epg_progname,
                                        epg_start: channel.epg_start,
                                        epg_end: channel.epg_end,
                                        archive: channel.have_archive,
                                        is_favorite: false,
                                        is_hidden: !!channel.hide,
                                        is_protected: !!channel.protected,
                                        is_video: !!channel.is_video
                                    })
                                }
                            }

                            commit('SET_CHANNEL_LIST', {groups, channels});

                            dispatch('getFavoriteChannels');
                            dispatch('getChannelsAspectRatio');

                            if (local._showHiddenChannels !== showHiddenChannels) {
                                local._showHiddenChannels = showHiddenChannels;
                            }

                            if (state.protectionCode !== protectionCode) {
                                commit('SET_PROTECTION_CODE', protectionCode);
                            }

                            resolve(data);
                        }
                    }
                })
            }
        });
    },

    getUrl({commit, dispatch, state}, {cid, gmt, protectionCode = local._protectionCode}) {
        return new Promise((resolve, reject) => {
            if (!gmt) gmt = 0;

            if (!cid) cid = state.currentChannel.id;

            Server.getStreamUrl(cid, gmt, protectionCode, (err, data) => {
                if (err) {
                    console.error(err.message);
                    location.reload();
                } else {
                    if (data.error) {
                        reject(data.error);
                    }
                    else {
                        resolve(data);
                    }
                }
            });
        });
    },
    teletekaGetUrl({commit, dispatch}, id) {
        return new Promise((resolve, reject) => {
            Server.getTeletekaUrl(id, (err, data) => {
                if (err) {
                    console.error(err.message);
                    location.reload();
                } else {
                    if (data.error) {
                        reject(data.error);
                    }
                    else {
                        if (data.url === 'protected') {
                            reject({code: 7});
                        }
                        else {
                            resolve(data);
                        }
                    }
                }
            });
        });
    },
    openChannel({commit, dispatch}, {channel, program, mode}) {

    },

    markChannelsAsFavorites({commit, dispatch}, favoriteChannels) {
        commit('DELETE_FAVORITE_GROUP');

        for (let channelId of favoriteChannels) {
            commit('MARK_CHANNEL_AS_FAVORITE', channelId);
        }

        if (favoriteChannels.length > 0) {
            commit('CREATE_FAVORITE_GROUP');
        }
    },

    getChannelsAspectRatio({commit, dispatch}) {
        let channelsAspectRatio;
        try {
            channelsAspectRatio = JSON.parse(localStorage.getItem('kartinatvWebplayer_channelsAspectRatio'));
        }
        catch (e) {
        }

        if (!channelsAspectRatio) channelsAspectRatio = {};

        commit('SET_CHANNELS_ASPECT_RATIO', channelsAspectRatio);
    },
    setVideoAspectRatio({commit, dispatch}, {videoAspectRatio, channelId}) {
        return new Promise(resolve => {
            commit('SET_VIDEO_ASPECT_RATIO', {videoAspectRatio, channelId});

            dispatch('getChannelsAspectRatio');

            resolve();
        });
    },

    setCurrentChannel({commit, dispatch}, channel) {
        commit('SET_CURRENT_CHANNEL', channel);
    },

    setLoadingChannel({commit, dispatch}, value) {
        commit('SET_LOADING_CHANNEL', value);
    },

    checkProtectionCode({commit, dispatch, state}, channelIsProtected) {
        return new Promise(resolve => {
            let protectionCode = state.protectionCode;

            if (channelIsProtected && !protectionCode) {
                protectionCode = prompt('Введите родительский пароль', '');
            }

            resolve(protectionCode);
        });
    },
    setProtectionCode({commit, dispatch}, value) {
        commit('SET_PROTECTION_CODE', value);
    },
    setShowHiddenChannels({commit, dispatch}, value) {
        local._showHiddenChannels = value;
    }
};

const mutations = {
    SET_CHANNEL_VISIBILITY(state, {channelId, value}) {
        const channel = state.channels.find(val => val.id === channelId);
        channel && (Vue.set(channel, 'is_hidden', value));
    },

    SET_CHANNEL_LIST(state, {groups, channels}) {
        state.groups = groups;
        state.channels = channels;
    },

    DELETE_FAVORITE_GROUP(state) {
        let favGroupIndex = state.groups.findIndex(group => group.id === 0);
        if (~favGroupIndex) {
            state.groups.splice(favGroupIndex, 1);
        }
    },
    MARK_CHANNEL_AS_FAVORITE(state, channelId) {
        let favoriteChannel = state.channels.find(val => val.id === channelId);
        favoriteChannel && (favoriteChannel.is_favorite = true);
    },
    CREATE_FAVORITE_GROUP(state) {
        state.groups.unshift({
            id: 0,
            name: 'Избранные',
            color: '#FFC107'
        })
    },

    SET_CHANNELS_ASPECT_RATIO(state, channelsAspectRatio) {
        state.channelsAspectRatio = channelsAspectRatio;
    },
    SET_VIDEO_ASPECT_RATIO(state, {videoAspectRatio, channelId}) {
        let channelsAspectRatio = state.channelsAspectRatio || {};

        if (videoAspectRatio.modes[videoAspectRatio.index] !== 'auto') {
            channelsAspectRatio[channelId] = videoAspectRatio.index;
        }
        else {
            delete channelsAspectRatio[channelId];
        }

        try {
            localStorage.setItem('kartinatvWebplayer_channelsAspectRatio', JSON.stringify(channelsAspectRatio));
        }
        catch(e) {}
    },

    SET_CURRENT_CHANNEL(state, channel) {
        state.currentChannel = channel;
    },

    SET_LOADING_CHANNEL(state, value) {
        state.loadingChannel = value;
    },

    SET_PROTECTION_CODE(state, value) {
        state.protectionCode = value;
    },

    SET(state, values) {
        for (let key in values) {
            state[key] = values[key];
        }
    }

};

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/channels.js